import styled from 'styled-components';
import FormWithProvider from 'components/forms/form/Form';

export const FormWithProviderStyled = styled(FormWithProvider)`
  fieldset {
    label > .tooltip-container {
      margin-left: 5px;
    }
  }
`;

export const LeftAlignedTooltipContent = styled.div`
  text-align: left;

  ul {
    padding-left: 15px;
  }
`;
